import { Injectable } from "@angular/core";

import { AggregateCriteria, ExecutionResult, IAggregate } from "@tylertech/tyler-api-types";

import { AggregateHelperService } from "./aggregateHelperService";
import { AggregateService } from "./aggregateService.g";

@Injectable()
export class AggregateManagerService
{
    private _aggregateCriteriaList: Array<AggregateCriteria>;
    private _aggregates: Array<IAggregate>;
    private _aggregatesLoaded: boolean;
    private _chartAggregates: Array<IAggregate>;
    private _chartAggregatesLoaded: boolean;

    constructor(
        private readonly $aggregateService: AggregateService,
        private readonly $aggregateHelperService: AggregateHelperService
    )
    {
        this._aggregates = [];
        this._aggregatesLoaded = false;

        this._chartAggregates = [];
        this._chartAggregatesLoaded = false;
    }

    /**
     * TODO - why do we need a service tracking state?
     * @deprecated
     */
    get AggregateCriterias(): Array<AggregateCriteria> { return this._aggregateCriteriaList; }
    /**
     * TODO - why do we need a service tracking state?
     * @deprecated
     */
    get Aggregates(): Array<IAggregate> { return this._aggregates; }
    /**
     * TODO - why do we need a service tracking state?
     * @deprecated
     */
    get AggregatesLoaded(): boolean { return this._aggregatesLoaded; }
    /**
     * TODO - why do we need a service tracking state?
     * @deprecated
     */
    get ChartAggregates(): Array<IAggregate> { return this._chartAggregates; }
    /**
     * TODO - why do we need a service tracking state?
     * @deprecated
     */
    get ChartAggregatesLoaded(): boolean { return this._chartAggregatesLoaded; }

    RefetchAggregates(): Promise<void>
    {
        this._aggregatesLoaded = false;
        this._chartAggregatesLoaded = false;
        this.Aggregates.length = 0;
        this.ChartAggregates.length = 0;
        return this.fetchAggregates();
    }

    private fetchAggregates(): Promise<void>
    {
        this._aggregatesLoaded = false;
        this._chartAggregatesLoaded = false;
        return this.$aggregateService.GetAggregateCriterias()
            .then((aggregateCriteria: Array<AggregateCriteria>) =>
            {
                aggregateCriteria.sort(this.compareAggregateCriteria);

                this._aggregateCriteriaList = aggregateCriteria;
                this._aggregatesLoaded = true;
            });
    }

    /**
     * TODO - Why did we put logic for how a component wants to display data in this service?

     * @param column
     * @returns
     */
    GetChartAggregatesForColumn(column: number): Array<IAggregate>
    {
        return this.ChartAggregates.filter(x =>
        {
            const dataEle = this.$aggregateHelperService.getDataElementByLabel(
                "ColumnIndex", x.AggregateCardDataElements);

            return (dataEle?.Value === column.toString()) || column === 0;
        });
    }

    private static GetPosition(crit: AggregateCriteria): string
    {
        const p = crit.Parameters.find(v => v.Caption === "Position");
        if (!p)
        {
            return "";
        }

        const matches = /^([A-Z]+)?-?(.+?)$/i.exec(p?.Value || "");
        return matches?.length === 3
            ? matches[2]
            : "";
    }

    private compareAggregateCriteria(a: AggregateCriteria, b: AggregateCriteria): number
    {
        const aPos = AggregateManagerService.GetPosition(a);
        const bPos = AggregateManagerService.GetPosition(b);
        if (aPos === bPos)
        {
            return a.ProviderId.localeCompare(b.ProviderId);
        }
        return aPos > bPos ? 1 : -1;
    }

    private loadChartAggregate(aggregate: IAggregate): void
    {
        const hasChart = this.$aggregateHelperService.getDataElementByLabel(
            "HasChart",
            aggregate.AggregateCardDataElements
        );
        if (hasChart && hasChart.Value === "true")
        {
            this.ChartAggregates.push(aggregate);
        }
    }

    FetchAggregate(providerId: string): Promise<Array<IAggregate>>
    {
        return this.$aggregateService.GetAggregatesForProvider({ ProviderId: providerId })
            .then((executionResult: ExecutionResult<Array<IAggregate>>) =>
            {
                const aggregates = executionResult.Result;
                if (aggregates)
                {
                    aggregates.forEach(aggregate =>
                    {
                        const alwaysShowAgg = this.$aggregateHelperService.getDataElementByLabel(
                            "AlwaysShow", aggregate.AggregateCardDataElements);

                        if (alwaysShowAgg)
                        {
                            /*
                             * TODO: why are we needing a timeout here? Was it an issue with doing too much work in an
                             * angularjs digest cycle? or making sure that the change was applied in the DOM?
                             */
                            const unexplainedSevenSeconds = 700;
                            setTimeout(() =>
                            {
                                this.reloadAggregate(aggregate);
                            }, unexplainedSevenSeconds);
                        }
                        else
                        {
                            this.reloadAggregate(aggregate);
                        }
                    });
                }

                this._aggregatesLoaded = true;
                this._chartAggregatesLoaded = true;

                return aggregates;
            });
    }

    private reloadAggregate(aggregate: IAggregate): void
    {
        const preExistingAggregate = this.Aggregates.find(
            v => v.AggregateProviderId === aggregate.AggregateProviderId);
        if (!preExistingAggregate
            && (aggregate.Count > 0
                || this.$aggregateHelperService.getDataElementByLabel("AlwaysShow", aggregate.AggregateCardDataElements)))
        {
            this.Aggregates.push(aggregate);
            this.loadChartAggregate(aggregate);
            return;
        }

        /* if (preExistingAggregate)
        {
            preExistingAggregate = aggregate;
        }
        preExistingAggregate = this.ChartAggregates.find(v => v.AggregateProviderId === aggregate.AggregateProviderId);
        if (preExistingAggregate)
        {
            preExistingAggregate = aggregate;
        } */
    }
}
